export default __webpack_public_path__ + "images/R2.db5a475.png";